(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-account-hub"] && !Shopify.designMode) return;
  try {
    
  (()=>{const euro=(c)=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format((c||0)/100);document.querySelectorAll('[data-account-rewards]').forEach(async(card)=>{try{const response=await fetch(card.dataset.endpoint,{headers:{Accept:'application/json'}});const data=await response.json();if(!response.ok||!data.loggedIn)throw new Error();card.querySelector('[data-reward-balance]').textContent=euro(data.wallet.availableCents);card.querySelector('[data-reward-rights]').textContent=`${card.dataset.gachaLabel} ${data.wallet.gachaRights} ${card.dataset.rightUnit} · ${card.dataset.lotteryLabel} ${data.wallet.lotteryRights} ${card.dataset.rightUnit}`;}catch{card.querySelector('[data-reward-balance]').textContent='—';card.querySelector('[data-reward-rights]').textContent=card.dataset.rewardsError;}});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-camera"] && !Shopify.designMode) return;
  try {
    
  if (!window.dlfCameraModalBound) {
    window.dlfCameraModalBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-camera-open]');
      if (trigger) {
        const id = trigger.dataset.youtubeId;
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        const dialog = trigger.closest('[data-live-camera-section]').querySelector('[data-camera-modal]');
        const frameHost = dialog.querySelector('[data-camera-frame]');
        const frame = document.createElement('iframe');
        frame.title = trigger.getAttribute('aria-label');
        frame.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frameHost.replaceChildren(frame);
        dialog.querySelector('[data-camera-youtube]').href = `https://www.youtube.com/watch?v=${id}`;
        dialog.cameraTrigger = trigger;
        dialog.showModal();
        return;
      }
      const close = event.target.closest('[data-camera-close]');
      if (close) close.closest('[data-camera-modal]').close();
      if (event.target.matches('[data-camera-modal]')) event.target.close();
    });
    document.addEventListener('close', (event) => {
      if (!event.target.matches('[data-camera-modal]')) return;
      event.target.querySelector('[data-camera-frame]').replaceChildren();
      event.target.cameraTrigger?.focus();
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-strip"]) return;
  try {
    
  (() => {
    const shuffle = (section) => {
      if (section.dataset.randomOrder !== 'true' || section.dataset.randomized === 'true') return;
      const track = section.querySelector('[data-promotion-track]');
      if (!track) return;
      const cards = [...track.querySelectorAll('[data-promotion-card]')];
      for (let index = cards.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
      }
      cards.forEach((card) => track.append(card));
      section.dataset.randomized = 'true';
    };

    const initialize = (root = document) => {
      root.querySelectorAll('[data-promotion-strip]').forEach(shuffle);
      if (root.matches?.('[data-promotion-strip]')) shuffle(root);
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
